import { render, staticRenderFns } from "./InAgeHeader.vue?vue&type=template&id=40c6b2ed&"
import script from "./InAgeHeader.vue?vue&type=script&lang=js&"
export * from "./InAgeHeader.vue?vue&type=script&lang=js&"
import style0 from "./InAgeHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports